import { Link, useLocation } from "react-router-dom";
import AuthLayout from "./AuthLayout";

export default function ConfirmEmailDone() {
  const location = useLocation();
  const message =
    location.state?.message || "Your email has been confirmed successfully.";

  return (
    <AuthLayout heading="Email Confirmed" message={message}>
      <Link
        to="/login"
        className="mt-4 hover:underline text-sm text-center block"
      >
        Log in
      </Link>
    </AuthLayout>
  );
}
